import React from "react";
import { HiSparkles } from "react-icons/hi2";
import style from "./aiAssist.module.css";
import { useAiEnabled } from "../../context/AppConfigContext";

/**
 * Small pill that marks a value as AI-generated. Rendered next to field labels
 * (and inside the suggestions panel) so it's always clear what the user is
 * reviewing vs. what they typed. Purely presentational.
 *
 * Renders nothing when AI is switched off for this deployment. Gating it here
 * rather than at each of its ~15 call sites means a client with AI off never
 * sees an AI badge, including on content whose fields were AI-generated
 * elsewhere.
 *
 * @param {number} [confidence] 0..1 — when provided, shown as a percentage.
 * @param {string} [label]      Override the default "AI Generated" text.
 * @param {"sm"|"md"} [size]
 */
const AiGeneratedBadge = ({ confidence, label = "AI Generated", size = "md", title }) => {
  const aiEnabled = useAiEnabled();
  const pct =
    typeof confidence === "number" ? `${Math.round(confidence * 100)}%` : null;

  if (!aiEnabled) return null;

  return (
    <span
      className={`${style.aiBadge} ${size === "sm" ? style.aiBadgeSm : ""}`}
      title={title || (pct ? `AI confidence: ${pct}` : "Generated by AI")}
    >
      <HiSparkles className={style.aiBadgeIcon} aria-hidden="true" />
      <span>{label}</span>
      {pct && <span className={style.aiBadgeConf}>{pct}</span>}
    </span>
  );
};

export default AiGeneratedBadge;
